var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import theme from '../theme';
import { LabelSmall } from '../labels';
var TagStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  padding: 4px 8px;\n"], ["\n  background: ", ";\n  padding: 4px 8px;\n"])), theme.tints.mint);
export var Tag = function (props) {
    return (_jsx(TagStyle, __assign({ className: props.class }, { children: _jsx(LabelSmall, { children: props.text }) })));
};
var templateObject_1;
